<template>
    <div id="kakao-map">
        <div id="map" :style="{width:'100%;'}"></div>
    </div>
</template>

<script>
import * as config from '../../js/config';
import common from '../../js/common';
import EventBus from '../../js/event_bus';

export default {
    name: 'kakao-map',
    props: ['distance', 'map_type', 'mapSize'],
    components: {
    },
    data () {
        return {
            kakao_key: config.KAKAO_MAP_KEY,
            map: {},
            container: {},
            options: {},
            my_lat: '',
            my_lon: '',
            // distance: 0,
            store_list: [],
            my_marker: [],
            store_markers: [],
            store_labels: [],
            params: {}
        }
    },
    mounted(){
        this.$nextTick(function(){
            window.kakao && window.kakao.maps ? this.initMap() : this.addKakaoMapScript();
        });
    },
    computed: {
        
    },
    methods: {
        initComponent(params){
            // 내위치 마커 초기화
            for(var i=0; i<this.my_marker.length; i++){
                if(typeof this.my_marker[i].setMap() != 'undefined'){
                    this.my_marker[i].setMap(null);
                }
            }
            // 가맹점 마커 초기화
            for(var i=0; i<this.store_markers.length; i++){
                if(typeof this.store_markers[i].setMap() != 'undefined'){
                    this.store_markers[i].setMap(null);
                }
                
                if(typeof this.store_labels[i] != 'undefined'){
                    this.store_labels[i].close();
                }
            }
            common.setLocationData((data) => {
                this.my_lat = data.my_lat;
                this.my_lon = data.my_lon;
                var self = this;
                if(typeof params != 'undefined'){
                    params.my_lat = data.my_lat;
                    params.my_lon = data.my_lon;

                    this.params = params;
                    this.getData(self.params)

                }else{
                    this.getData(self.params)
                }
            });
            
        },
        getData(data){
            var type;
            data.distance = this.distance;
            common.getData(data.type, data, 
                (response) => {
                    this.store_list = response;
                    // map_type에 따라 마커 표시를 바꿔준다.
                    // list일 경우 -> 내 위치 마커, 가맹점들의 마커를 찍어줌
                    // detail일 경우 -> 해당 가맹점의 마커만 찍어줌
                    if(this.map_type == 'list'){
                        this.setStoreLocationMarker();
                        this.changeLocationMap(this.my_lat, this.my_lon);
                    }else if(this.map_type == 'store'){
                        this.setStoreLocationMarker();
                        this.map.setCenter(new kakao.maps.LatLng(this.store_list[0].latitude, this.store_list[0].longitude));
                    }

                    // 윈포윈도우
                    var infoTitle = document.querySelectorAll('.info-title');
                    infoTitle.forEach(function(e) {
                        var w = e.offsetWidth + 10;
                        var ml = w/2;
                        e.parentElement.style.top = "6%";
                        e.parentElement.style.left = "6%";
                        // e.parentElement.style.marginLeft = -ml+"px";
                        // e.parentElement.style.width = w+"px";
                        e.parentElement.previousSibling.style.display = "none";
                        e.parentElement.parentElement.style.border = "0px";
                        e.parentElement.parentElement.style.background = "unset";
                        e.parentElement.classList.add('info-title-wrap');
                        
                    });
            })
        },
        /********** KAKAO MAP **********/
        // index.html에도 script 설정되어있음
        addKakaoMapScript(){
            const script = document.createElement('script');
            /* global kakao */
            script.onload = () => kakao.maps.load(this.initMap);
            script.src = 'http://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey='+this.kakao_key;
            document.head.appendChild(script);
        },
        // 최초 맵 설정
        initMap() {
            var container = document.getElementById('map'),
                options = {
                center: new kakao.maps.LatLng(33.450701, 126.570667),
                level: 5
            };
            var map = new kakao.maps.Map(container, options);
            this.map = map;
            this.container = container;
            this.options = options;

            // 지도 타입 컨트롤을 지도에 표시
            var mapTypeControl = new kakao.maps.MapTypeControl();
            this.map.addControl(mapTypeControl, kakao.maps.ControlPosition.TOPRIGHT);

            if(this.map_type == 'store'){
                var data = {};
                data.type = config.REQ_STORE_INFO;
                data.store_id = common.getParams().store_id;
                this.initComponent(data);
            }
            
            
        },
        // 좌표 변경
        changeLocationMap(lat, lon){
            this.map.setCenter(new kakao.maps.LatLng(lat, lon));
            this.setMyLocationMarker(lat, lon)
        },
        // 내 위치 마커
        setMyLocationMarker(lat, lon){
            var markerImage = new kakao.maps.MarkerImage(
                'https://t1.daumcdn.net/localimg/localimages/07/2018/pc/img/marker_spot.png',
                new kakao.maps.Size(42, 42), new kakao.maps.Point(13, 34));
            
            var marker = new kakao.maps.Marker({
                map: this.map,
                position: new kakao.maps.LatLng(lat, lon)
            });
            this.my_marker.push(marker);
            marker.setImage(markerImage);
            marker.setMap(this.map);
        },
        // 가맹점 마커
        setStoreLocationMarker(){
            if(this.store_list.length > 0){
                for(var i=0; i<this.store_list.length; i++){
                    var position = new kakao.maps.LatLng(this.store_list[i].latitude, this.store_list[i].longitude);

                var markerImage = new kakao.maps.MarkerImage(
                    'https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/marker_red.png',
                    new kakao.maps.Size(49, 59), new kakao.maps.Point(13, 34));
                
                    var marker = new kakao.maps.Marker({
                        // map: this.map,
                        position: position
                    });
                    this.store_markers.push(marker);
                    marker.setImage(markerImage);
                    marker.setClickable(true);
                    marker.setMap(this.map);

                    this.setMarkerClickEvent(marker, this.store_list[i]);
                    // <span class="main-banner-title" v-if="store_name.length < 10">{{store_name}}</span>
                    //                     <span class="main-banner-title" v-else>{{store_name.substring(0, 12)}}..</span>
                    var store_name = this.store_list[i].store_name.length < 10 ? this.store_list[i].store_name : this.store_list[i].store_name.substring(0,10)+'..';
                    var label = new kakao.maps.InfoWindow({
                        content: '<span class="info-title">'+store_name+'</span>',
                        position: position,
                        removable: false
                    });
                    this.store_labels.push(label);
                    // label.setZIndex(3);
                    label.open(this.map, marker);
                }
            }
        },
        setMarkerClickEvent(marker, store){
            var self = this;
            if(this.map_type == 'list'){
                kakao.maps.event.addListener(marker, 'click', function() {
                    // 가맹점 상세페이지로 이동
                    // alert('ID: '+store.store_id+', 가맹점명: '+store.store_name );
                    var data = {};
                    data.store_id = store.store_id;
                    data.store_name = store.store_name;
                    common.setParams(data);
                    EventBus.$emit('detail-data', data);
                    self.$router.push('/detail');
                });
            }
        }
    }
}

</script>


<style>
</style>



// WEBPACK FOOTER //
// src/components/component/MapComponent.vue